/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  GET_CASUAL_GAMES = '[Game] Get Casual Games',
  GET_CASUAL_GAMES_SUCCESS = '[Game] Get Casual Games Success',
  GET_CASUAL_GAMES_FAILED = '[Game] Get Casual Games Failed',

  END_CASUAL_GAME = '[Game] End Casual Game',
  END_CASUAL_GAME_SUCCESS = '[Game] End Casual Game Success',
  END_CASUAL_GAME_FAILED = '[Game] End Casual Game Failed',

  END_LEAGUE_GAME = '[Game] End League Game',
  END_LEAGUE_GAME_SUCCESS = '[Game] End League Game Success',
  END_LEAGUE_GAME_FAILED = '[Game] End League Game Failed',
}

export const getCasualGames = createAction(
  ActionTypes.GET_CASUAL_GAMES
);

export const getCasualGamesSuccess = createAction(
	ActionTypes.GET_CASUAL_GAMES_SUCCESS,
  props<{ data: any }>()
);

export const getCasualGamesFailed = createAction(
  ActionTypes.GET_CASUAL_GAMES_FAILED,
  props<{ data: any }>()
);

export const endCasualGame = createAction(
  ActionTypes.END_CASUAL_GAME,
  props<{ data: any }>()
);

export const endCasualGameSuccess = createAction(
	ActionTypes.END_CASUAL_GAME_SUCCESS,
  props<{ data: any }>()
);

export const endCasualGameFailed = createAction(
  ActionTypes.END_CASUAL_GAME_FAILED,
  props<{ data: any }>()
);

export const endLeagueGame = createAction(
  ActionTypes.END_LEAGUE_GAME,
  props<{ data: any, league: any, game: any }>()
);

export const endLeagueGameSuccess = createAction(
	ActionTypes.END_LEAGUE_GAME_SUCCESS,
  props<{ data: any, league: any }>()
);

export const endLeagueGameFailed = createAction(
  ActionTypes.END_LEAGUE_GAME_FAILED,
  props<{ data: any }>()
);